const ERRORS = {
  taken(inputName) {
    return `${inputName} is already taken`;
  },
  blank(inputName) {
    return `${inputName} can't be empty`;
  }
};

export default {
  data() {
    return {
      error: ''
    };
  },
  methods: {
    errorMessage(inputName, errorCode) {
      const name = inputName
        .replace(/_/g, ' ')
        .replace(/^(.)/, char => char.toUpperCase())
        .replace(/\s(.)/g, char => char.toUpperCase());
      const generateErrorMessage = ERRORS[errorCode];
      if (typeof generateErrorMessage === 'function') {
        return generateErrorMessage(name);
      }
      return null;
    },
    addErrorToInput(error) {
      const [, inputName, errorCode] = error.code.match(/(.*)\.(.*)/);
      const errorMessage = this.errorMessage(inputName, errorCode) || error.details;
      const input = inputName
        .replace(/_/g, ' ')
        .replace(/\s(.)/g, char => char.toUpperCase())
        .replace(/\s/g, '')
        .replace(/^(.)/, char => char.toLowerCase());

      this.$set(this.errors, input, errorMessage);
    },
    handleRequestError(response) {
      if (response.status === 422) {
        response.body.errors.forEach(error => this.addErrorToInput(error));
      } else {
        this.error = 'Something went wrong';
      }
    }
  }
};
